import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import Decimal from 'decimal.js/decimal.js';
import { Organization, Payment } from '../../shared/sdk/models';
import { paymentTypes } from '../payment.service';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { WhiteLabelService } from 'src/app/shared/services/whitelabel.service';
import { OrganizationService } from '../../organizations/organization.service';
import { notZeroValidator } from '../../shared/directives/valid-payment.directive';
import { LanguageService } from '../../shared/services/language.service';
import { MyDpDateService } from '../../shared/services/my-dp-date.service';
import { PaymentService } from '../payment.service';

@Component({
  selector: 'app-payment-add',
  templateUrl: './payment-add.component.html',
  styleUrls: ['./payment-add.component.css'],
})
export class PaymentAddComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() payment: Payment;
  @ViewChild('paymentAmount', { static: true }) paymentAmount: ElementRef;
  paymentForm: FormGroup;
  paymentTypes: any;
  loading: boolean;
  sent: boolean;
  private activeOrg: Organization;
  private onDestroy$: Subject<void> = new Subject();

  constructor(
    public wls: WhiteLabelService,
    private activeModal: NgbActiveModal,
    private paymentService: PaymentService,
    private languageService: LanguageService,
    private orgService: OrganizationService,
    private translate: TranslateService,
    private fb: FormBuilder,
    private dateService: MyDpDateService,
  ) {}

  ngOnInit() {
    this.paymentTypes = paymentTypes;

    for (const type of this.paymentTypes) {
      this.translate
        .get(type.name)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((res) => (type.name = res));
    }

    // Form control
    this.paymentForm = this.fb.group({
      id: [],
      documentId: [this.payment.documentId, Validators.required],
      amount: [
        this.payment.amount || 0,
        [Validators.required, notZeroValidator(this.languageService)],
      ],
      date: [, Validators.required],
      type: ['bank', Validators.required],
      tag: [''],
      note: [''],
      organizationId: [],
      custom: [],
    });

    let date: moment.Moment;

    try {
      date = moment(this.payment.date);
    } catch (error) {
      date = moment();
    }

    if (!this.payment.id) {
      this.payment = new Payment();
      this.payment.date = date.toDate();
    } else {
      this.payment = new Payment(this.payment);
      this.paymentForm.patchValue(this.payment);
    }

    this.paymentForm.controls.date.patchValue(this.dateService.generate(date));

    this.paymentForm.controls.amount.patchValue(
      this.languageService.formatNumber(this.paymentForm.controls.amount.value),
    );

    this.orgService.active.pipe(take(1)).subscribe((org: Organization) => {
      this.activeOrg = org;
      this.paymentForm.controls.organizationId.setValue(org.id);
    });
  }

  ngAfterViewInit() {
    setTimeout(() => this.paymentAmount.nativeElement.focus(), 100);
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  onClose() {
    this.activeModal.dismiss();
  }

  onSave() {
    this.sent = true;

    if (this.paymentForm.valid) {
      this.loading = true;
      this.payment = this.paymentForm.value;

      this.payment.amount = new Decimal(
        this.languageService.unformatNumber(this.payment.amount),
      ).toNumber();
      this.payment.date = this.dateService.parse(this.payment.date);

      this.paymentService[!this.payment.id ? 'create' : 'update'](
        this.payment.id || this.activeOrg.id,
        this.payment,
      ).subscribe(
        (payment: Payment) => {
          this.activeModal.close(payment);
          this.loading = false;
        },
        () => (this.loading = false),
      );
    }
  }
}
